<template>
  <div>
    <PageAppBar>Courses</PageAppBar>
    <div v-if="!message" class="page-content header-clear-small">
      <div v-if="!Object.keys(courses).length">
        <mushonga></mushonga>
      </div>

      <div v-else v-for="course in courses.data.data" :key="(course.id)">
        <div>
          <div class="card card-style mb-3 ">

           <div class="card card-style mx-0 rounded-0 mb-0 preload-img" data-card-height="200"
                 data-src="https://picsum.photos/200/300"
                 :style="'height: 200px; background-image: url(&quot;'+image_url+course.photo+'&quot;);'">
              <div class="card-bottom ml-3 mb-3">
                <h1 class="heading">{{ course.title}}</h1>
                 <p class="description">Description: {{ course.description }}</p>
              </div>
              <div class="card-overlay bg-black opacity-70"></div>
            </div>
            <div class="content">
              <router-link :to="'/course/'+course.id"  class="font-13 mt-n2 mb-6 details ">More Details</router-link>
            </div>
            

          </div>
        </div>
      </div>
      <FooterBar></FooterBar>
    </div>
    <div v-else-if="message.length" class="page-content header-clear-small">
      <div v-if="message.length">
        {{message}}
      </div>
      <div class="card card-style">
        <div class="content">
          <h1>TBD Courses</h1>
          <p class="color-highlight font-12 mt-n3 pt-1 mb-2">You have joined TSP{{$route.params.id}}</p>
          <p v-if="Object.keys(course).length">To begin you have to start making your contributions of ${{course.contribution_amount}}
            starting {{course.start_date}} for {{course.number_of_contributions}} {{course.contribution_interval}}s </p>
        </div>
      </div>
      <FooterBar> </FooterBar>
    </div>
  </div>
</template>

<script>
// import { mapMutations } from "vuex"
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import global from "@/mixins/global";
import axios from "axios";
export default {
  data(){
    return {
      courses: [],
      course: {}
    }
  },
  mixins: [global],
  mounted() {
    axios.get(this.base_url+"courses", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{this.courses = response}).catch(error=>{this.error = error})
  },
  components: {
    PageAppBar,
    FooterBar
  },
  name: "Course.vue",
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap');
.center-align{
  text-align: center !important;

}
.heading{
  
  margin-left: 2px;
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  color: #fff;
}
.description{
  margin-left: 2px !important;
  color: #fff;
}
.details{
  font-size: 30px;
   font-family: 'Roboto', sans-serif;
   font-weight: 900;
  color: #DA4453;
}

</style>